import React, { useEffect } from "react";
import { Box, Flex, Grid, GridItem } from "@chakra-ui/react";
import DashboardBarChart from "../components/DashboardBarChart";
import DashboardLineChart from "../components/DashboardLineChart";
import UpcomingExams from "../components/UpcomingExams";
import { fetchAdminDashboard } from "../redux/slices/dashboardSlice";
import { useDispatch, useSelector } from "react-redux";
import DashboardDisplayCards from "../components/DashboardDisplayCards";
import img1 from "../Assets/Images/dcard-image-1.png";
import img2 from "../Assets/Images/dcard-image-2.png";
import img3 from "../Assets/Images/dcard-image-3.png";
import img4 from "../Assets/Images/dcard-image-4.png";
import AdminDashboardGenderReport from "../components/AdminDashboardGenderReport";
import DasboardCards from "../components/DasboardCards";
import AdminDashboardExamReport from "../components/AdminDashboardExamReport";

const AdminDashboard = () => {
  const dispatch = useDispatch();
  const adminDashboardData = useSelector(
    (state) => state?.dashboard?.adminDashboard
  );

  useEffect(() => {
    dispatch(fetchAdminDashboard());
  }, [dispatch]);

  const details = [
    {
      name: "Total Number Of Students",
      number: adminDashboardData?.memberCategoryCount?.totalStudent,
      bgcolor: "#FFF6EC",
      icon: img1,
      imgBgColor: "#FFE9BC",
    },
    {
      name: "Total Number Of NYSC Members",
      number: adminDashboardData?.memberCategoryCount?.totalNYSC,
      bgcolor: "#FCEAE4",
      icon: img2,
      imgBgColor:"#F8D4C8"
    },
    {
      name: "Total Number Of Graduates",
      number: adminDashboardData?.memberCategoryCount?.totalGraduate,
      bgcolor: "#EFE6F6",
      icon: img3,
      imgBgColor:"#E7D1F8"
    },
    {
      name: "Total Number Of Fellows",
      number: adminDashboardData?.memberCategoryCount?.totalFellow,
      bgcolor: "#FFECF0",
      icon: img1,
      imgBgColor:"#F4BCCA"
    },
    {
      name: "Total Number Of Associates",
      number: adminDashboardData?.memberCategoryCount?.totalAssociate,
      bgcolor: "#EDF2FB",
      icon: img4,
      imgBgColor:"#416EFC4A"
    },
  ];

  const paidSubsriptionData =  {
    name: "Total Members With Paid Subscription",
    number: 50000,
    colors: ["#FFE7B9", "#FCEAE4", "#EDA3AA", "#812773", "#3064FC"],
    pieChartData: [
      { name: "Students", value: 5000 },
      { name: "NYSC", value: 6000 },
      { name: "Associates ", value: 10000 },
      { name: "Fellows", value: 25000 },
      { name: "Graduates ", value: 10000 },
    ],
  }

  const examReportData ={title:"Exam Report", color1:"#1976D2", color2:"#812773", color3:"#EB3D4D", 
    text1:"No of Students That wrote exam", text2:"No of qualified students", text3:"No of unqualified students", 
    value1:"58.33%", value2:"25%", value3:"8%"
  };
  const memberReportData ={title:"Member Report", color1:"#F86624", color2:"#22CAAD", color3:"#EB3D4D", 
    text1:"Total Members", text2:"Total Non-Members", text3:"Total Old Members", 
    value1:"120,000", value2:"50,000", value3:"5000"
  };
  
  return (
    <Flex
      flexDirection={"column"}
      gap={"20px"}
      py={"30px"}
      minH={"100vh"}
      px={3}
    >
      <Flex
        flexDirection={["column", "column", "column", "row"]}
        justifyContent={["center", "center", "flex-start"]}
        alignItems={"center"}
        gap={"20px"}
      >
        <Box w={["100%", "100%", "100%"]} bgColor={"#FFFFFF"} borderRadius={"14px"} border={"1px solid #E3EBEE"} padding={"20px"}>
          <Grid gridTemplateColumns={["repeat(1, 1fr)", "repeat(2, 1fr)","repeat(3, 1fr)","repeat(4, 1fr)", "repeat(5, 1fr)"]} gap={5}>
          {
            details?.map((detail, index) => (
              <GridItem>
                <DashboardDisplayCards key={index} {...detail} />
              </GridItem>
            ))
          }
          </Grid>
        </Box>
      </Flex>
      <Flex
        mt={6}
        flexDirection={["column", "column", "column", "row"]}
        justifyContent={["center", "center", "space-between"]}
        alignItems={"center"}
        gap={"20px"}
      >
        <Box w={["100%", "100%", "100%", "60%", "70%"]}>
          <DashboardLineChart
            lineChartData={adminDashboardData?.memberCountPerMonth}
          />
        </Box>
        <Box width={["100%", "100%", "100%", "40%", "30%"]}>
          <UpcomingExams
            upcomingEvents={adminDashboardData?.events}
            title={"Upcoming Events"}
          />
        </Box>
      </Flex>
      <Grid gridTemplateColumns={["repeat(1, 1fr)", "repeat(2, 1fr)","repeat(2, 1fr)", "repeat(2, 1fr)"]} gap={5}>
        <GridItem>
          <AdminDashboardGenderReport/>
        </GridItem>
        <GridItem>
        <DasboardCards
          showValue={false}
          name={paidSubsriptionData?.name}
          number={paidSubsriptionData?.number}
          colors={paidSubsriptionData?.colors}
          pieChartData={paidSubsriptionData?.pieChartData}
        />
        </GridItem>
      </Grid>
      <DashboardBarChart barChartData={adminDashboardData?.memberUpgradeCounts} />
      <DashboardBarChart barChartData={adminDashboardData?.memberUpgradeCounts} title={"Activity Report Per Month"} color1={"#812773"} color2={"#CD73D1"} text1={"Active Members"} text2={"Dormant members"} />
      <Grid gridTemplateColumns={["repeat(1, 1fr)", "repeat(2, 1fr)","repeat(2, 1fr)", "repeat(2, 1fr)"]} gap={5}>
        <GridItem>
          <AdminDashboardExamReport {...examReportData} />
        </GridItem>
        <GridItem>
          <AdminDashboardExamReport {...memberReportData} />
        </GridItem>
      </Grid>
    </Flex>
  );
};

export default AdminDashboard;
